
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Msg,
Divider,
XButton
},
data() {
return {
activeId: "",
icon: "success",
title: "提交成功",
description:
'您已经成功提交展商信息，请等待负责人通知。<br/>',
buttons: [
{
type: "primary",
text: "返回首页",
link: "/"
}
]
};
},
async mounted() {
this.activeId = this.$route.params.activeId;
if (!this.activeId) {
this.activeId = this.$route.params.id;
}
this.buttons[0].link = "/index/" + this.activeId;
},
methods: {
}
};



// WEBPACK FOOTER //
// ./src/components/success.vue